import React from "react";
import { Lock, EyeOff, ShieldAlert } from "lucide-react";
import { cls } from "../../ui";

const TONE = {
  PUBLIC: ["bg-white text-slate-500 border-slate-300", null],
  RESTRICTED: ["bg-slate-100 text-slate-700 border-slate-400", ShieldAlert],
  SEALED: ["bg-amber-100 text-amber-900 border-amber-500", Lock],
  EXPUNGEMENT_PENDING: ["bg-red-50 text-red-800 border-red-300", ShieldAlert],
  EXPUNGED: ["bg-red-800 text-white border-red-800", EyeOff],
};
export const STATUS_TONE = { PENDING: "text-slate-600", UNDER_REVIEW: "text-ujms-deep", HEARING_SCHEDULED: "text-amber-700", APPROVED: "text-emerald-700", DENIED: "text-red-700", COMPLETED: "text-slate-900" };
export const nice = (s) => String(s || "").replace(/_/g, " ");

/** Record-access state chip. PUBLIC is rendered only when `showPublic` is set (lists stay quiet by default). */
export function AccessChip({ state, showPublic = false, testId }) {
  const st = state || "PUBLIC";
  if (st === "PUBLIC" && !showPublic) return null;
  const [tone, Icon] = TONE[st] || TONE.PUBLIC;
  return <span className={cls("inline-flex items-center gap-0.5 text-[9px] font-bold border px-1 leading-[13px] whitespace-nowrap", tone)} data-testid={testId} data-access={st}>{Icon && <Icon className="w-2.5 h-2.5" />} {nice(st)}</span>;
}
